// "EN VIVO" indicator — a 6px green dot with a soft outer ring that
// breathes out infinitely. The ONLY thing visually moving at idle on
// the Análisis tab. Says "this number is live, not a static
// snapshot."
//
// Sits inside the page subtitle next to the comparison label. Reused
// downstream (handoff calls for it next to "Cerrados hoy" on /home)
// — keep this primitive lean so the visual language stays consistent
// across surfaces.
//
// Accessibility: aria-label carries the meaning. The pulse itself is
// aria-hidden because it's decorative; the text "en vivo" reaches
// screen readers via the visible label. Under prefers-reduced-motion
// the outer ring stays static (the @keyframes live-pulse override in
// globals.css collapses to a no-op).

'use client';

export function LivePulse({ label = 'en vivo' }: { label?: string }) {
  return (
    <span
      aria-label={label}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        fontSize: 10.5,
        fontFamily: 'var(--font-mono)',
        color: 'var(--ink-4)',
        letterSpacing: 0.6,
        textTransform: 'uppercase',
      }}
    >
      <span
        aria-hidden
        style={{
          position: 'relative',
          display: 'inline-block',
          width: 6,
          height: 6,
        }}
      >
        <span
          style={{
            position: 'absolute',
            inset: 0,
            borderRadius: '50%',
            background: 'var(--dot-active)',
          }}
        />
        <span
          style={{
            position: 'absolute',
            inset: -3,
            borderRadius: '50%',
            background: 'var(--dot-active)',
            opacity: 0.4,
            animation: 'live-pulse 1800ms ease-out infinite',
          }}
        />
      </span>
      {label}
    </span>
  );
}
